interface CatalogPaginationProps {
  page: number;
  pageCount: number;
  onChange: (page: number) => void;
}

export function CatalogPagination({ page, pageCount, onChange }: CatalogPaginationProps) {
  if (pageCount <= 1) return null;
  return <nav className="catalog-pagination-bar" aria-label="Страницы списка"><button className="catalog-button" type="button" disabled={page <= 1} onClick={() => onChange(page - 1)}>Назад</button><span>{page} из {pageCount}</span><button className="catalog-button" type="button" disabled={page >= pageCount} onClick={() => onChange(page + 1)}>Далее</button></nav>;
}
